import { useEffect, useState } from "react";
import { api } from "../api/axios";
import { toast } from "react-toastify";
import { useI18n } from "../../i18n/I18nContext";

export default function WishlistButton({
  productId,
  onToggle,
  initialFavorite = false,
}) {
  const { t } = useI18n();
  const [favorite, setFavorite] = useState(initialFavorite);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setFavorite(initialFavorite);
  }, [initialFavorite]);

  const toggleFavorite = async (e) => {
    e.stopPropagation();
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error(t("Precisa estar autenticado para adicionar favoritos"));
      return;
    }

    const newFavorite = !favorite;

    try {
      setLoading(true);
      setFavorite(newFavorite);

      const res = await api.post("/api/v1/wishlist/toggle", {
        product_id: productId,
      });

      setFavorite(!!res.data.favorite);
      if (onToggle) onToggle(!!res.data.favorite);

      if (res.data.favorite) {
        toast.success(t("Produto adicionado aos favoritos!"));
      } else {
        toast.info(t("Produto removido dos favoritos."));
      }
    } catch (err) {
      console.error("Erro ao alterar wishlist:", err);
      setFavorite(!newFavorite);
      if (onToggle) onToggle(!newFavorite);
      toast.error(t("Erro ao atualizar favoritos."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={toggleFavorite}
      disabled={loading}
      className={`flex h-10 w-10 items-center justify-center rounded-full border-none text-3xl transition-colors duration-200 ${
        favorite ? "text-red-600" : "text-black"
      }`}
    >
      {favorite ? "♥" : "♡"}
    </button>
  );
}